export default function MapLoader() {
  return new Promise((resolve) => {
    if (window.AMap) {
      resolve(window.AMap);
    } else {
      // 创建script标签，引入外部文件
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = 'https://webapi.amap.com/maps?v=1.3&key=e43073ed258d040e414701ae373bba4f';
      document.body.appendChild(script);
      // 监听加载事件
      script.onload = function () {
        if (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete') {
          resolve(window.AMap);
        }
      };
    }
  });
}
